class SizeGuide {
  constructor() {
    this.button = document.querySelector('[js-product="sizeGuideButton"]');
    this.modal = document.querySelector('[js-product="sizeGuideModal"]');
    this.closeButton = document.querySelector(
      '[js-product="sizeGuideCloseButton"]'
    );
    this.overlay = document.querySelector(
      '[js-product="sizeGuideBackgroundOverlay"]'
    );

    this.bindEvents();
  }

  bindEvents() {
    if (!this.button || !this.modal || !this.closeButton || !this.overlay)
      return;

    this.button.addEventListener("click", () => this.openModal());
    this.closeButton.addEventListener("click", () => this.closeModal());
    this.overlay.addEventListener("click", () => this.closeModal());

    // Close on escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.closeModal();
    });
  }

  openModal() {
    this.modal.classList.remove("is-hidden");
    this.overlay.classList.remove("is-hidden");
    document.body.style.overflow = "hidden"; // Prevent scrolling when modal is open
  }

  closeModal() {
    this.modal.classList.add("is-hidden");
    this.overlay.classList.add("is-hidden");
    document.body.style.overflow = ""; // Restore scrolling
  }
}

// Initialize the size guide when the DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new SizeGuide();
});
